module.exports = __webpack_public_path__ + "f1c7b2b8b0626573e9a8eb13fa73e72d.pdf";